export const DEFAULT_REVIEW_REGION = 'Paris';

export const CITY_TO_DEPARTMENT = {
  Paris: 'Paris',
  'Aix En Provence': 'Bouches-du-Rhone',
  Amiens: 'Somme',
  Angers: 'Maine-et-Loire',
  Bagnolet: 'Seine-Saint-Denis',
  Bordeaux: 'Gironde',
  Bron: 'Rhone',
  Cenon: 'Gironde',
  Cergy: 'Val-d-Oise',
  'Clermont-ferrand': 'Puy-de-Dome',
  Grenoble: 'Isere',
  'Joinville Le Pont': 'Val-de-Marne',
  Lille: 'Nord',
  Lyon: 'Rhone',
  Marseille: 'Bouches-du-Rhone',
  Merignac: 'Gironde',
  Montpellier: 'Herault',
  Nantes: 'Loire-Atlantique',
  Nice: 'Alpes-Maritimes',
  Palaiseau: 'Essonne',
  Perpignan: 'Pyrenees-Orientales',
  Rennes: 'Ille-et-Vilaine',
  Roubaix: 'Nord',
  Rouen: 'Seine-Maritime',
  Sevres: 'Hauts-de-Seine',
  Strasbourg: 'Bas-Rhin',
  Talence: 'Gironde',
  Toulouse: 'Haute-Garonne',
  Tours: 'Indre-et-Loire',
  Valenciennes: 'Nord',
  Villeurbanne: 'Rhone',
};

export const normalizeName = (name) => String(name || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()
  .trim()
  .replace(/-/g, ' ')
  .replace(/'/g, ' ')
  .replace(/\s+/g, ' ');

export const toRegionKey = (name) => String(name || '')
  .trim()
  .toLowerCase()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '');

export const buildDepartmentToCities = () => {
  const map = {};
  Object.entries(CITY_TO_DEPARTMENT).forEach(([city, department]) => {
    if (!map[department]) map[department] = [];
    map[department].push(city);
  });
  Object.keys(map).forEach((department) => {
    map[department] = map[department].sort((a, b) => a.localeCompare(b, 'fr'));
  });
  return map;
};

export const DEPARTMENT_TO_CITIES = buildDepartmentToCities();

export const DEPARTMENT_DISPLAY_CITIES = {
  ...DEPARTMENT_TO_CITIES,
  Isere: ['Lyon'],
  Lyon: ['Lyon'],
};

export const getDepartmentDisplayCities = (department) => (
  DEPARTMENT_DISPLAY_CITIES[department]
  || DEPARTMENT_TO_CITIES[department]
  || [department]
);

export const getReviewCityDisplayName = (city, department = '') => {
  const cityName = String(city || '').trim();
  if (cityName === 'Grenoble' || normalizeName(cityName) === 'grenoble') {
    return 'Lyon';
  }

  if (!cityName) {
    return getDepartmentDisplayCities(department)[0] || department || '';
  }

  return cityName;
};

export const DEPARTMENT_WITH_CITIES_SET = new Set(
  Object.values(CITY_TO_DEPARTMENT).map(normalizeName)
);

export const PARIS_REVIEW_DEPARTMENTS = [
  'Paris',
  'Hauts-de-Seine',
  'Seine-Saint-Denis',
  'Val-de-Marne',
  'Essonne',
  "Val-d'Oise",
];

export const PARIS_MERGED_DEPARTMENTS = new Set(
  PARIS_REVIEW_DEPARTMENTS.map(normalizeName)
);

export const resolveRegionName = (name) => (
  PARIS_MERGED_DEPARTMENTS.has(normalizeName(name))
    ? DEFAULT_REVIEW_REGION
    : normalizeName(name) === 'isere' || normalizeName(name) === 'grenoble'
      ? 'Lyon'
      : name
);
